import { OrderedParallelEnumerable } from "../OrderedParallelEnumerable.js";
export const orderByAsync = (source, keySelector, comparer) => {
    return OrderedParallelEnumerable.generateAsync(source, keySelector, true, comparer);
};
